import ButtonPrimary from "shared/Button/ButtonPrimary";
import React from "react";
import { Helmet } from "react-helmet";
import NcImage from "shared/NcImage/NcImage";
import I404Png from "images/404.png";

const Page404: React.FC = () => (
  <div className="nc-Page404">
    <Helmet>
      <title>Urban Care Young Talent | 404 Sayfa Bulunamadı</title>
    </Helmet>
    <div className="container relative pt-5 pb-16 lg:pb-20 lg:pt-5">
      {/* HEADER */}
      <header className="text-center max-w-2xl mx-auto space-y-2">
        <NcImage src={I404Png} />
        <span className="block text-sm text-black sm:text-base tracking-wider font-semibold">
          ARADIĞINIZ SAYFA MEVCUT DEĞİL.{" "}
        </span>
        <div className="pt-8">
          <ButtonPrimary href="/">ANA SAYFA'YA DÖN</ButtonPrimary>
        </div>
      </header>
    </div>
  </div>
);

export default Page404;
